// Stable seat numbering for the night target ring (audit P2).
//
// The ring filters the viewer out (unless the ability can self-target), and
// numbering the FILTERED array shifted every seat after the viewer's down by
// one — the numbers players call out at the table disagreed with the lobby
// and host numbering. Number by the player's roster index FIRST, then filter,
// so seat numbers match everywhere regardless of who is hidden.

export interface RingSeat<T> {
  player: T;
  /** 1-based seat number — the player's index in the full roster, matching
   *  the lobby and host lists. */
  seat: number;
}

export function ringSeats<T extends { id: string }>(
  players: readonly T[],
  meId: string,
  canSelfTarget: boolean,
): RingSeat<T>[] {
  return players
    .map((player, i) => ({ player, seat: i + 1 }))
    .filter(({ player }) => player.id !== meId || canSelfTarget);
}
